import React from "react";
import { observer } from "mobx-react";
import useToggleState from "components/hooks/useToggleState";
import ModalPopup from "components/modal";
import UI from "components/UI";
import Button from "components/buttons";
import commonPopupStore from "../store/CommonPopupStore";
import {OZHViewerProp} from "components/report/OZHViewer";

export interface OZReportViewerPopupParam extends OZHViewerProp{
    title: string;
    onClose: () => void;
}

export default observer(OZReportViewerPopup)

function OZReportViewerPopup(props:OZReportViewerPopupParam) {
    const modalState = useToggleState({showing: true});

    const onClickHandler = () => {
        (async () => modalState.toggle())();
        (async () => props.onClose())();
    }

    return (
        <ModalPopup
            open={modalState.isShowing}
            title={props.title}
            size="mid"
            onClose={onClickHandler}
            onAfterClose={()=>{commonPopupStore.closeLastPopup()}}
        >
            <div className="modal-con">
                <UI.ReportViewer
                    style={props.style}
                    className={props.className}
                    parameter={props.parameter}
                    reportName={props.reportName}
                />
            </div>
            <div className="modal-bottom">
                <Button color='pri' size="md" onClick={onClickHandler}>닫기</Button>
            </div>
        </ModalPopup>
    )

}